import React from 'react';
import clsx from 'clsx';
import { Breadcrumbs } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const ProjectPageBreadcrumb = (props) => {
  const { selectedPage, selectedProject } = props;

  return (
      selectedProject > -1 && JSON.parse(localStorage.getItem('data')) !== null && (
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <span className={clsx(selectedPage > -1 ? 'boldBlue' : 'lightBlue')}>
            {JSON.parse(localStorage.getItem('data'))[selectedProject].name}
          </span>
          {selectedPage > -1 ? (
            <span className="lightBlue">
              {JSON.parse(localStorage.getItem('data'))[selectedProject].pages[selectedPage].name}
            </span>
          ) : null}
        </Breadcrumbs>
      ) 
  );
};

export default ProjectPageBreadcrumb;
